/* unplugin-vue-components disabled */import { render } from "./edit-person.vue?vue&type=template&id=474cd157&scoped=true"
import script from "./edit-person.vue?vue&type=script&lang=js"
export * from "./edit-person.vue?vue&type=script&lang=js"

import "./edit-person.vue?vue&type=style&index=0&id=474cd157&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474cd157"],['__file',"src/pages/pulse/tracker/edit-person.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "474cd157"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('474cd157', __exports__)) {
    api.reload('474cd157', __exports__)
  }
  
  module.hot.accept("./edit-person.vue?vue&type=template&id=474cd157&scoped=true", () => {
    api.rerender('474cd157', render)
  })

}


export default __exports__